"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BriefcaseIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** BriefcaseIcon */


var BriefcaseIcon = function BriefcaseIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Briefcase" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    d: "M7.15 4.88a2.398 2.398 0 00-.094.214h3.888a2.398 2.398 0 00-.094-.214 1.805 1.805 0 00-.61-.71c-.278-.186-.671-.326-1.24-.326s-.962.14-1.24.326a1.805 1.805 0 00-.61.71zm4.594-.447c.115.229.194.456.25.66h3.131c.483 0 .875.393.875.876v8.312a.875.875 0 01-.875.875H2.875A.875.875 0 012 14.281V5.97c0-.484.392-.875.875-.875h3.131c.056-.205.135-.432.25-.661.194-.388.492-.79.95-1.095.46-.307 1.05-.494 1.794-.494s1.335.187 1.795.494c.457.305.755.707.95 1.095zM3 14.156v-3.75h5.5v.5h1v-.5H15v3.75H3zm6.5-4.75H15V6.094H3v3.312h5.5v-.5h1v.5z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
};

exports.BriefcaseIcon = BriefcaseIcon;
BriefcaseIcon.displayName = "BriefcaseIcon";